import { EMAIL_VALID_CHARACTERS_REGEX } from '@/constants';

export const onSetEmailValue = (value: string) =>
  value.toLocaleLowerCase().replace(EMAIL_VALID_CHARACTERS_REGEX, '').trim();

export const onChangeEmailValue = (e: React.ChangeEvent<HTMLInputElement>) =>
  (e.target.value = e.target.value
    .toLocaleLowerCase()
    .replace(EMAIL_VALID_CHARACTERS_REGEX, '')
    .trim());
